<div class="w-100 h-100 position-relative overflow-hidden grid-item-space gallery-module"
*ngIf="module" id="module-item-{{i}}" 
[ngClass]="{'has-video':videoelement.video_id}">

        <div class="preloader" [ngStyle]="{'background':preloader_color}" [ngClass]="{'fade-out':postLoaded}"></div>
        <img *ngIf="screenWidth > 767 && bannerItem" class="gallery-item-image"  src="{{bannerItem}}" (load)="loadedImage()">
        <img *ngIf="screenWidth <= 767" class="gallery-item-image" src="{{module.photo_gallery.url}}" (load)="loadedImage()">
        <div
        *ngIf="videoelement.video_id" 
        class="w-100 h-100 d-block video-module-item overflow-hidden">
                <app-video-module 
                class="w-100 h-100 d-block "
                [videoelement]='videoelement'
                [size]='module.element_size'
                [i]='i'>
                </app-video-module>
        </div>

        <div class="view-port-detect"
                inViewport
                [inViewportOptions]="{ threshold: [0] }"
                (inViewportAction)="onIntersection($event)">

        </div>
</div>
